import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, ParamMap} from '@angular/router';
import {BillingService} from '../../../shared/services/billing.service';
import {Subscription} from 'rxjs';
import * as _ from 'lodash';
import {NgForm} from '@angular/forms';
import * as moment from 'moment';
import {PATIENTS_VIEW} from '../../../patient/utils/views-settings';
import {ORGANIZATION_VIEW} from '../../../settings/utils/views-settings';
import {PatientDialogComponent} from "../../../patient/dialogs/patient-dialog/patient-dialog.component";

@Component({
  selector: 'ftb-quotation',
  templateUrl: './quotation.component.html',
  styleUrls: ['./quotation.component.scss']
})
export class QuotationComponent implements OnInit {
  quotation: any = {
    number: null,
    doc_date: moment(),
    // valid_duration:30,
    beneficiary_type: 'patient',
    lines: [],
  };
  cls = 'quotation';
  loading: Subscription;
  routes = {list: '/invoicing/quotation/', form: '/invoicing/quotation/quotation-form/'};
  loadedObject=null;
  seqQuery = {
    cls: 'invoicing.Quotation',
    label: 'invoicing.quotation_number',
    fieldName: 'number',
    reloadDeleted: true
  };
  patientInputSettings = _.assignIn(_.cloneDeep(PATIENTS_VIEW), {selectable: false});
  organizationInputSettings = _.assignIn(_.cloneDeep(ORGANIZATION_VIEW), {selectable: false});
  patientDialog = PatientDialogComponent;

  @ViewChild('quotationForm', {static: true}) public quotationForm: NgForm;

  constructor(private route: ActivatedRoute, private  billingService: BillingService) {
  }

  ngOnInit() {
    this.route.params.subscribe((params: ParamMap) => this.initData(params));
  }

  initData(params) {
    if (_.get(params, 'id')) {
      this.loading = this.billingService.getBillingDoc(this.cls, _.get(params, 'id'))
        .subscribe(data => this.quotation = data);
    }
  }


  onSequenceChange(data) {
    if (typeof data === 'string') {
      this.quotation.number = data;
    } else {
      this.quotation.number = data[this.seqQuery.fieldName];
      this.quotation.id = data['id'];
    }
  }

  onModelChange(data) {
    this.quotation = data;
  }
}
